import colors from '@constants/colors';
import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { ReactNode } from 'react';

type SkeletonShape = 'text' | 'block' | 'circle';

interface SkeletonProps {
    width?: string | number;
    height?: string | number;
    shape?: SkeletonShape;
    className?: string;
    style?: React.CSSProperties;
    children?: ReactNode;
}

function Skeleton({
    width = '100%', height = 20, shape = 'text', className, style, children,
}: SkeletonProps) {
    return (
        <Base
            className={className}
            style={style}
            width={width}
            height={height}
            shape={shape} >
            {children}
        </Base>
    );
}

const pulse = keyframes`
    0% { opacity: 1; }
    50% { opacity: 0.4; }
    100% { opacity: 1; }
`;

const Base = styled.div<{
    width: string | number;
    height: string | number;
    shape: SkeletonShape;
}>`
    width: ${({ width }) => (typeof width === 'string' ? width : `${width}px`)};
    height: ${({ height }) => (typeof height === 'string' ? height : `${height}px`)};
    min-width: ${({ width }) => (typeof width === 'string' ? width : `${width}px`)};
    min-height: ${({ height }) => (typeof height === 'string' ? height : `${height}px`)};
    border-radius: ${({ shape }) => {
        switch (shape) {
        case 'text': return 'var(--radius-xs)';
        case 'block': return 'var(--radius-sm)';
        default: return 'var(--radius-full)';
        }
    }};
    background-color: var(--color-background-raised); 
    animation: ${pulse} 1.5s ease-in-out infinite;
    position: relative;
`;

export default Skeleton;
